import { Stack, TextField, Tiles } from 'braid-design-system';
import { Controller } from 'react-hook-form';

import { nonEmptyString } from '../validation.ts';

export const ContactInfo = () => (
  <Stack space="small">
    <Controller
      name="partnerName"
      rules={{
        validate: nonEmptyString(
          'Enter the name of the software your customers use with SEEK',
        ),
      }}
      render={({ field, fieldState }) => (
        <TextField
          id="security-breach-partner-name"
          onChange={field.onChange}
          label="What is the name of the software your customers use with SEEK? "
          value={field.value}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
        />
      )}
    />
    <Tiles space="small" columns={2}>
      <Controller
        name="contactName"
        rules={{
          validate: (value) => {
            if (!/\S/.test(value)) {
              return 'Enter the name of the person we should contact about this issue';
            }
          },
        }}
        render={({ field, fieldState }) => (
          <TextField
            id="security-breach-contact-name"
            onChange={field.onChange}
            label="Contact name"
            value={field.value}
            message={fieldState.error?.message}
            tone={fieldState.invalid ? 'critical' : undefined}
          />
        )}
      />
      <Controller
        name="contactEmail"
        rules={{
          validate: (value) => {
            if (!/\S/.test(value)) {
              return 'Enter a valid email address';
            }
          },
        }}
        render={({ field, fieldState }) => (
          <TextField
            id="security-breach-contact-email"
            onChange={field.onChange}
            label="Contact email"
            value={field.value}
            message={fieldState.error?.message}
            tone={fieldState.invalid ? 'critical' : undefined}
            type="email"
          />
        )}
      />

      <Controller
        name="contactPhone"
        rules={{
          validate: (value) => {
            if (!/\S/.test(value)) {
              return 'Enter a valid phone number';
            }
          },
        }}
        render={({ field, fieldState }) => (
          <TextField
            id="security-breach-contact-phone"
            onChange={field.onChange}
            label="Contact phone"
            value={field.value}
            message={fieldState.error?.message}
            tone={fieldState.invalid ? 'critical' : undefined}
            type="tel"
          />
        )}
      />
      <Controller
        name="contactHours"
        rules={{
          validate: (value) => {
            if (!/\S/.test(value)) {
              return 'Enter the hours when the contact is available';
            }
          },
        }}
        render={({ field, fieldState }) => (
          <TextField
            id="security-breach-contact-hours"
            onChange={field.onChange}
            label="Contact hours"
            value={field.value}
            message={fieldState.error?.message}
            tone={fieldState.invalid ? 'critical' : undefined}
          />
        )}
      />
    </Tiles>
  </Stack>
);
